var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(1 0 0 1 0 0)",
    fill: "rgb(113, 113, 238)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96116 0.172056C6.19804 -0.0529311 6.56813 -0.0578554 6.81091 0.160749L6.81165 0.16141C7.08281 0.405567 7.08771 0.828328 6.82314 1.07961L3.07017 4.64411C2.83329 4.8691 2.4632 4.87403 2.22042 4.65542L2.21968 4.65476C2.18413 4.62274 2.15315 4.58766 2.12675 4.55029C2.11622 4.54024 2.10592 4.52979 2.0959 4.51895L0.18434 2.45156C-0.0776513 2.16821 -0.0581537 1.72604 0.228633 1.46782L0.229411 1.46712C0.510888 1.21368 0.943785 1.23349 1.20093 1.5116L2.76723 3.20559L5.96116 0.172056Z",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 1 2.86616 3.87287)",
    fill: "rgb(255, 255, 255)"
  })));
};
export default SvgSuccess;